/** `type="number"` allows `e` for exponents; palette stops are plain decimals only. */
export function blockPaletteStopExponentKey(event: KeyboardEvent): boolean {
  if (event.key !== 'e' && event.key !== 'E') {
    return false;
  }
  event.preventDefault();
  return true;
}
